export default __webpack_public_path__ + "static/media/antimatter.90f11e71.svg";